/**
 * Member profile — sibling of picks/leaderboard/groups so the WC tab bar stays on the origin tab.
 * Params: memberId (required), groupId (optional), wcTab (leaderboard | groups | picks),
 * self ('1' when the viewer tapped their own row — renders the editable Picks feed),
 * rank (the viewer's leaderboard rank, shown in the self header).
 */

import { useLocalSearchParams } from 'expo-router';
import { MemberProfileView } from '../../../components/worldcup/MemberProfileView/MemberProfileView';

export default function WorldCupMemberProfileRoute() {
  const { groupId, memberId, wcTab, self, rank } = useLocalSearchParams<{
    groupId?: string;
    memberId: string;
    wcTab?: string;
    self?: string;
    rank?: string;
  }>();
  const parsedRank = rank ? Number(rank) : null;
  return (
    <MemberProfileView
      groupId={groupId ?? ''}
      memberId={memberId ?? ''}
      wcTab={wcTab}
      isSelf={self === '1'}
      rank={parsedRank != null && Number.isFinite(parsedRank) ? parsedRank : null}
    />
  );
}
